import { FlagIssuesFormData } from 'dashboard/forms/FormFlagIssues';
import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ReportIssueType } from 'dashboard/lib/constants/reportIssue';
import { Inquiry } from 'dashboard/models/inquiry';
import {
  Verification,
  VERIFICATION_API_MODEL_TYPES_WITH_QA_VERIFICATION,
} from 'dashboard/models/verification';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiModel, ApiResponse } from 'lib/interfaces/api';

export const inquiryApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    updateInquiryTags: builder.mutation<ApiResponse<Inquiry>, { id: string; tags: string[] }>({
      query: ({ id, tags }) => {
        return SessionClientDashboard.postResourceAction<Inquiry>(
          {
            type: ApiModel.Inquiry,
            id,
          },
          'set-tags',
          { meta: { 'tag-id': tags } },
        );
      },
    }),
    flagInquiryIssues: builder.mutation<
      ApiResponse<Inquiry>,
      {
        id: string;
        verifications: Verification[];
      } & FlagIssuesFormData
    >({
      query: async ({
        id,
        verifications,
        issueVerifications,
        issueType,
        content,
        responseType,
        addAsFraudulent,
      }) => {
        let addAsFraudulentText = 'none';

        let verificationGroundTruth;
        switch (issueType) {
          case ReportIssueType.Classification:
            verificationGroundTruth = issueVerifications.map((issue) => ({
              'verification-id': issue.verificationId,
              'ground-truth': issue.correctValue,
            }));
            break;
          case ReportIssueType.Extraction:
            verificationGroundTruth = issueVerifications.map((issue) => ({
              'verification-id': issue.verificationId,
              /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
              'ground-truth': { [issue.attributeName]: issue.correctValue },
            }));
            break;
          case ReportIssueType.Fraud:
            addAsFraudulentText = addAsFraudulent ? 'fraud' : 'none';
            // Flag all verifications that have QA support for inquiry as fraud
            verificationGroundTruth = verifications
              .filter((ver) => VERIFICATION_API_MODEL_TYPES_WITH_QA_VERIFICATION.includes(ver.type))
              .map((ver) => ({
                'verification-id': ver.id,
                'ground-truth': { status: 'failed' },
              }));
            break;
        }

        return await SessionClientDashboard.postResourceAction<Inquiry>(
          {
            type: ApiModel.Inquiry,
            id,
          },
          'flag-issues',
          {
            meta: {
              'issue-type': issueType,
              /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
              'issue-verifications': verificationGroundTruth,
              content: content,
              'response-type': responseType,
              'add-to-global-registry': addAsFraudulentText,
            },
          },
        );
      },
    }),
  }),
});

// Hooks are autogenerated based on the defined endpoints
export const { useUpdateInquiryTagsMutation, useFlagInquiryIssuesMutation } = inquiryApi;
